import { $Q, $Qll } from '../utils/query-selector';
import { dataToggle } from '../utils/toggle-dataset';

/**
 * Process outside clicks
 * @param {HTMLElement} select select event fire
 * @param {HTMLElement} closestCustomSelect main wrapper custom select
 * @returns void
 */
function onClickOutsideSelect(closestCustomSelect) {
  document.addEventListener('click', function onClickOutsideEvent(e) {
    if (
      !closestCustomSelect.contains(e.target) &&
      closestCustomSelect.dataset.active === 'true'
    ) {
      dataToggle(closestCustomSelect, false);
      document.removeEventListener('click', onClickOutsideEvent);
    }
  });
}

/**
 * Load click event into custom selects
 */
function onClickCustomSelect() {
  const selects = $Qll('.custom-select__fire-event');
  selects.forEach((item) => {
    // prevent event bubbling when we have anchor elements inside of
    // the div
    if ($Q('a[href]', item)) {
      $Q('a[href]', item).addEventListener('click', (e) => e.stopPropagation());
    }

    item.addEventListener('click', () => {
      const closestCustomSelect = item.closest('.custom-select');

      dataToggle(closestCustomSelect, false);
      onClickOutsideSelect(closestCustomSelect);
    });
  });
}

/**
 * Init events
 */
export function setupCustomSelect() {
  onClickCustomSelect();
}
